<ng-container *ngTemplateOutlet="reportTemplate">
</ng-container>
<ng-template #reportTemplate>
  <div class="modal-header d-flex justify-content-center hide-print">
    <button class="btn btn-light rounded-0 me-3" (click)="closeModal()">
      <i class="bi bi-x"></i>
      Close</button>
    <button class="btn btn-light rounded-0" (click)="printNow()">
      <i class="bi bi-printer-fill"></i>
      PRINT</button>
  </div>
  <div class="content d-flex flex-column overflow-auto">
    <div class="modal-body bg-white">
      <div class="d-flex flex-column border-page align-items-stretch">

        <div class="d-flex justify-content-between align-items-center bg-black ps-4 pe-4">
          <div class="ps-5">
            <img src="./assets/media/logos/free_float_platform_logo.png" alt="FF Logo" height="45" class="pt-1 pb-1 hide-print"/>
            <img src="./assets/media/logos/free_float_platform_logo.png" alt="FF Logo" height="45" class="pt-1 pb-1"/>
          </div>
          <p class="text-white mb-0">{{title}}</p>
          <div class="pe-5"></div>
        </div>
        <ng-container *ngFor="let company of data">
          <div class="d-flex justify-content-between border-bottom align-items-center ps-4 pe-4 pt-4 pb-3">
            <app-company-logo [company]="company" [showTitle]="true" [showLogo]="true" [maxTitleLines]="2" [scale]="1.5"></app-company-logo>
            <div class="d-flex flex-column bg-body-tertiary text-center justify-content-end pe-3 ps-3">
              <p class="bg-body-tertiary mb-0">TEAM POWER</p>
              <p class="display-6 text-primary fw-bold" [ngClass]="{'blurred-strong': company.is_premium}">{{company.team_power | number : '1.3-3'}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 order-sm-4">
              <table class="table table-hover overflow-hidden stat-table">
                <thead>
                <tr>
                  <th scope="col">Director</th>
                  <th scope="col">Year</th>
                  <th scope="col">Age</th>
                  <th scope="col">Overall</th>
                  <th scope="col">EBITDA</th>
                  <th scope="col">Carbon Intensity</th>
                  <th scope="col">TSR</th>
                  <th scope="col">Controversies</th>
                  <th scope="col">Director Gender</th>
                  <th scope="col">Influence</th>
                </tr>
                </thead>
                <tbody class="bg-white">
                <ng-container *ngIf="company.is_premium else visibleTemplate">
                  <tr *ngFor="let directorship of company.directorships">
                    <td>{{[directorship.director.firstname,directorship.director.middlenames,directorship.director.lastname] | joinArray}}</td>
                    <td>{{[directorship.start_date, directorship.end_date] | yearRange}}</td>
                    <td>{{directorship.director.age | number}}</td>
                    <td class="blurred">{{0.001 | number : '1.3-3'}}</td>
                    <td class="blurred">{{0.001 | number : '1.3-3'}}</td>
                    <td class="blurred">{{0.001 | number : '1.3-3'}}</td>
                    <td class="blurred">{{0.001 | number : '1.3-3'}}</td>
                    <td class="blurred">{{0.001 | number : '1.3-3'}}</td>
                    <td class="blurred">{{"XXXXXXX" | titlecase}}</td>
                    <td class="blurred">{{0.001 / 100 | percent}}</td>
                  </tr>
                </ng-container>
                <ng-template #visibleTemplate>
                  <tr *ngFor="let directorship of company.directorships">
                    <td>{{[directorship.director.firstname,directorship.director.middlenames,directorship.director.lastname] | joinArray}}</td>
                    <td>{{[directorship.start_date, directorship.end_date] | yearRange}}</td>
                    <td>{{directorship.director.age | number}}</td>
                    <td>{{directorship.overall | number : '1.3-3'}}</td>
                    <td>{{directorship.ebitda | number : '1.3-3'}}</td>
                    <td>{{directorship.carbon_intensity | number : '1.3-3'}}</td>
                    <td>{{directorship.tsr | number : '1.3-3'}}</td>
                    <td>{{directorship.controversies | number : '1.3-3'}}</td>
                    <td>{{directorship.director.gender | titlecase}}</td>
                    <td>{{directorship.influence / 100 | percent}}</td>
                  </tr>
                </ng-template>
                </tbody>
              </table>
            </div>
          </div>
<!--          <div class="row ps-4 pe-4 pt-4 pb-4 flex-fill">-->
<!--&lt;!&ndash;            <div class="col-sm-3 order-sm-4 border-end hide-print">&ndash;&gt;-->
<!--&lt;!&ndash;              <h5> Lorem ipsum dolor sit amet, consect</h5>&ndash;&gt;-->
<!--&lt;!&ndash;              <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="col-sm-12 order-sm-4">-->
<!--              -->

<!--            </div>-->
<!--          </div>-->
        </ng-container>

      </div>

    </div>
  </div>
</ng-template>
<iframe #iframe></iframe>

